import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=80c8e912"
import script from "./recovery.vue?vue&type=script&lang=js"
export * from "./recovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports